import { render, staticRenderFns } from "./PublicationParticipantsTab.vue?vue&type=template&id=23f6c4c2&scoped=true"
import script from "./PublicationParticipantsTab.vue?vue&type=script&lang=js"
export * from "./PublicationParticipantsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f6c4c2",
  null
  
)

export default component.exports